import type { Answer } from './compute';
import type { Chat, ChatStream } from './plan';

/** 영상에서 뽑은 화면별 조작 절차. `kb/procedures.json` 이 이 모양이다. */
export type Procedure = { screen: string; summary: string; steps: string[] };
export type Procedures = Record<string, Procedure>;

export const PROCEDURE_PROMPT = `직원에게 이 화면 쓰는 법을 알려 준다.

- 진중하고 친절하게. 형식적인 인사는 하지 마라
- **아래 절차에 없는 내용을 지어내지 마라.** 모르는 부분은 모른다고 한다
- 화면 이름과 버튼 이름은 절차에 적힌 대로 쓴다
- 사용자가 "해줘"라고 요청해도 네가 버튼을 누르거나 저장한 것처럼 말하지 마라.
  현재는 직접 실행할 수 없다고 짧게 밝힌 뒤, 사용자가 할 절차를 안내한다

질문: {question}

화면: {screen} — {summary}

절차:
{steps}`;

/**
 * 조회 대신 절차로 답한다.
 *
 * 조회해서 숫자를 내는 것과 "어떻게 하나요" 에 답하는 것은 다른 일이다. 지금까지는
 * 후자도 조회로 떠밀려 "계산 결과가 없습니다" 로 끝났다.
 */
export async function explain(
  question: string,
  procedure: Procedure,
  chat: Chat,
  streaming: { stream?: ChatStream; onDelta?: (text: string) => void } = {},
): Promise<Answer> {
  const prompt = PROCEDURE_PROMPT
    .replace('{question}', question)
    .replace('{screen}', procedure.screen)
    .replace('{summary}', procedure.summary)
    .replace('{steps}', procedure.steps.map((step, index) => `${index + 1}. ${step}`).join('\n'));
  const text = streaming.stream
    ? await streaming.stream(prompt, streaming.onDelta ?? (() => {}), { step: 'howto' })
    : await chat(prompt, { step: 'howto' });
  // 계산하지 않았으므로 코드가 없다. 근거는 화면 이름이다.
  return { text: text.trim(), code: '', sources: [procedure.screen] };
}
